<template>
  <div class="vw100 minh100vh">

    <MyNav :current="current" />

    <div class="w-per100 column a-center">

      <div class="w-per100 column a-center bg-F7F7F7">
        <div class="w-per81_25 pb65 minh500">
          
          <div class="w-per100 bg-w py15 pl5 pr11 row j-sb mt12 br10">
            <div class="w-per15 p20">
              <div class="w-per100 lh40 ft16 font-Regular pl10 pointer" @click="toSearch(item)" :class="index==categoryList.length - 1?'':'bdb-EEEEEE'" v-for="(item,index) in categoryList" :key="index">
                {{ item.name }}
              </div>
            </div>
            <div class="w-per45 br10">
              <el-carousel ref="bannershow" loop height="15.625vw" autoplay arrow="never" :interval="5000">
                <el-carousel-item v-for="(item,index) in banners" :key="index">
                  <div class="w-vw100 column flex_center relative h300 br10" @click.stop="toPath(item)">
                    <div class="w-per100 h300 br10">
                      <img loading="lazy" class="w-per100 fit-cover h300 br10" :src="getImageUrl(item.image)" alt="" />
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="w-per20 h300 column j-sb">
              <div class="w-per100 h-per48 br10 bg-FF8E29-FFFFFF bd-EEEEEE py8 px10">
                <div class="row a-center">
                  <img class="butie" :src="$getAssetUrl('/shopImgs/baiyibutie.png')" alt="">
                  <span class="ft16 ml10">{{ $t('限时特惠') }}</span>
                </div>
                <div class="w-per100 py10 px10 ox-a">
                  <div class="w-per100 row j-sb nowrap">
                    <div class="column a-center pointer" v-for="(item,index) in tagList" :key="index" @click="toDetail(item)">
                      <img class="wh80" :src="getImageUrl(item.image)" alt="">
                      <div class="ft16 c-E02A22">￥{{ item.price }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-per100 h-per48 br10 bg-00903B-FFFFFF bd-EEEEEE row a-center px16">
                <div class="text-vertical text-center c-00903B font-Bold" :class="locale=='en'?'ft16':'ft20'">{{ $t('佰信畅销') }}</div>
                <div class="flex1 mx10">
                  <div class="w-per100 py10 ox-a">
                    <div class="w-per100 row nowrap">
                      <div class="wh118 br10 row ml10 pointer" v-for="(item,index) in sellList" :key="index" @click="toDetail(item)">
                        <img class="wh118 br10" :src="getImageUrl(item.image)" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="w_per16 h300 bg-F7F8FC br10 p20">
              <div class="w-per100 row a-center">
                <img loading="lazy" class="wh68 br-per50 fit-cover pointer" @click="toCenter" :src="getImageUrl(token ? userInfo.avatar : $getAssetUrl('/shopImgs/photo.png'))" alt="" />
                <div class="ml15 flex1" @click="toCenter">
                  <div class="ft20 bolder lh30">{{$t('Hi~上午好')}}</div>
                  <div class="ft20 lh30 pointer">{{token?userInfo.username:$t('注册')}}</div>
                </div>
              </div>
              <div class="w-per100 column a-center mt20" v-if="!token">
                <div class="ft16 font-Bold dis1">{{ $t('登录佰信纸业后更多优惠') }}</div>
                <div class="ft14 font-Regular mt18 dis1">{{ $t('登录可享，专属优惠，贴心推荐!') }}</div>
                <div class="w-per100 h40 row flex-center bg-00903B c-w ft16 font-Regular pointer mt24" @click="toLogin">{{ $t('登录') }}</div>
              </div>
              <div class="w-per100 mt30" :class="token&&locale=='en'?'column a-center':'row a-center j-sa'">
                <div class="flex1 text-center ft14 lh36 font-Regular text-wrap text-center normal-break pointer" @click="toPush('/History')">{{ $t('浏览记录') }}</div>
                <div class="flex1 text-center ft14 lh36 font-Regular text-wrap text-center normal-break pointer" @click="toPush('/Collection')">{{ $t('商品收藏') }}</div>
                <div class="flex1 text-center ft14 lh36 font-Regular text-wrap text-center normal-break pointer" @click="toPush('/Mine')">{{ $t('我的账户') }}</div>
              </div>
            </div>
          </div>

          <!-- 分享赚钱 小商品 -->
          <div class="w-per100 bg-w py20 pl20 mt15 br10 row">
            <div class="w150 h190 row br10 pointer" @click.stop="toPath(item)">
              <img class="w-per100 h-per100 br10 fit-cover" :src="getImageUrl( shareImg.image ? shareImg.image : '' )" alt="">
            </div>
            <div class="flex1 ml15 o-h">
              <div class="w-per100 ox-a oy-h">
                <div class="row nowrap">
                  <div class="mx15 w110 h190 column j-sb a-center pointer" v-for="(item,index) in smallList" :key="index" @click="toDetail(item)">
                    <div class="wh110 row">
                      <img class="w-per100 h-per100 fit-cover" :src="getImageUrl(item.image ? item.image : '')" alt="">
                    </div>
                    <div class="dis1 ft16 mt20">{{ item.name }}</div>
                    <div class="ft16 c-E02A22">￥{{ item.price }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 广告位 -->
          <div class="w-per100 bg-w px20 py15 mt15 br10 row">
            <div class="w450 h380 br10 pointer" @click.stop="toPath(item)" v-if="imgList[0]" >
              <img class="w-per100 h-per100 br10" :src="getImageUrl(imgList[0]&&imgList[0].image ? imgList[0].image : '')" alt="">
            </div>
            <div class="flex1 h380 ml20 column wrap j-sb ac-se">
              <div class="w337 h180 pointer" @click.stop="toPath(item)" v-if="imgList[1]" >
                <img class="w-per100 h-per100 br10" :src="getImageUrl(imgList[1]&&imgList[1].image ? imgList[1].image : '')" alt="">
              </div>
              <div class="w337 h180 pointer" @click.stop="toPath(item)" v-if="imgList[2]" >
                <img class="w-per100 h-per100 br10" :src="getImageUrl(imgList[2]&&imgList[2].image ? imgList[2].image : '')" alt="">
              </div>
              <div class="w337 h180 pointer" @click.stop="toPath(item)" v-if="imgList[3]" >
                <img class="w-per100 h-per100 br10" :src="getImageUrl(imgList[3]&&imgList[3].image ? imgList[3].image : '')" alt="">
              </div>
              <div class="w337 h180 pointer" @click.stop="toPath(item)" v-if="imgList[4]" >
                <img class="w-per100 h-per100 br10" :src="getImageUrl(imgList[4]&&imgList[4].image ? imgList[4].image : '')" alt="">
              </div>
              <div class="w337 h180 pointer" @click.stop="toPath(item)" v-if="imgList[5]" >
                <img class="w-per100 h-per100 br10" :src="getImageUrl(imgList[5]&&imgList[5].image ? imgList[5].image : '')" alt="">
              </div>
              <div class="w337 h180 pointer" @click.stop="toPath(item)" v-if="imgList[6]" >
                <img class="w-per100 h-per100 br10" :src="getImageUrl(imgList[6]&&imgList[6].image ? imgList[6].image : '')" alt="">
              </div>
            </div>
          </div>

          <!-- 今日推荐 -->
          <div class="w-per100 bg-w mt15 br10">
            <div class="w-per100 py20 row j-sb a-center bdb-F2F2F2">
              <div class="row a-center">
                <div class="ml20 ft24 font-Bold">
                  {{$t('今日推荐')}}
                </div>
                <div class="ml40 row a-center">
                  <div class="row a-center pointer" @click="changeSales">
                    <div class="c-9 ft16">
                      {{$t('销量')}}
                    </div>
                    <div class="column a-center ml4">
                      <i class="ft12 lh12 el-icon-caret-top" :class=" !sales_volume ? 'c-00903B' : 'c-9' "></i>
                      <i class="ft12 lh12 el-icon-caret-bottom" :class=" sales_volume ? 'c-00903B' : 'c-9' "></i>
                    </div>
                  </div>
                  <div class="row a-center pointer ml26" @click="changePrice">
                    <div class="c-9 ft16">
                      {{$t('价格')}}
                    </div>
                    <div class="column a-center ml4">
                      <i class="ft12 lh12 el-icon-caret-top" :class=" !price_type ? 'c-00903B' : 'c-9' "></i>
                      <i class="ft12 lh12 el-icon-caret-bottom" :class=" price_type ? 'c-00903B' : 'c-9' "></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-9 ft16 pr40 pointer" @click="toSearch({id:0})">
                {{$t('更多')}}+
              </div>
            </div>

            <div class="w-per100 pl24 tuijian">
              <div class="w-per100 row wrap">
                <div class="w-per20 mt24 pointer" v-for="(item,index) in dataList" :key="index" @click="toDetail(item)">
                  <div class="wh280 brt10 row">
                    <img class="wh280 fit-cover brt10" :src="getImageUrl(item.image ? item.image : '')" alt="">
                  </div>
                  <div class="w280 pt10 pb12">
                    <div class="w-per100 row nowrap a-center o-h">
                      <goodsNameTag :tagList="item.tags1" :len="1" :needTop="true"></goodsNameTag>
                      <span class="text-nowrap over-h ft20 lh36">{{ item.name }}</span>
                    </div>
                    <!-- 标签 -->
                    <div class="o-h minh30">
                      <goodsTag :tags="item.tags2" :len="2"></goodsTag>
                    </div>
                    <!-- 价格 -->
                    <div class="w-per100 mt16 lh24">
                      <span class="">
                        <span class="ft22 c-E02A22 font-Bold">￥</span>
                        <span class="ft34 c-E02A22 font-Bold">{{Math.floor(item.price)}}</span>
                        <span class="ft18 c-E02A22 font-Bold">{{String(item.price).includes('.')?'.':''}}</span>
                        <span class="ft24 c-E02A22 font-Bold">{{String(item.price).includes('.')?String(item.price).slice(String(item.price).indexOf('.')+1):''}}</span>
                      </span>
                      <span class="mt8 ft16 c-9">
                        &nbsp;{{locale=='en' ? (item.total_volume>=1000 ? `${$t('已抢')}${(item.total_volume/1000).toFixed(1)}${$t('万')}${$t('件')}` : `${$t('已抢')}${item.total_volume}${$t('件')}`) : ( item.total_volume>=10000 ? `${$t('已抢')}${(item.total_volume/10000).toFixed(1)}${$t('万')}${$t('件')}` : `${$t('已抢')}${item.total_volume}${$t('件')}` )}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- 猜你喜欢 -->
          <div class="w-per100 bg-w mt15 br10 likeBox">
            <div class="w-per100 py20 row j-sb a-center bdb-F2F2F2">
              <div class="row a-center">
                <div class="ml20 ft24 font-Bold">
                  {{$t('猜你喜欢')}}
                </div>
              </div>
              <div class="c-9 ft16 pr40 pointer" @click="toSearch({id:0})">
                {{$t('查看更多')}}+
              </div>
            </div>

            <div class="w-per100 px30">
              <div class="w-per100 relative minh300" v-if="showList2.length>0">
                <div class="w-per100 row nowrap">
                  <div class="w-per20 mt24 pointer" v-for="(item,index) in showList2" :key="index" @click="toDetail(item)">
                    <div class="wh260 brt10 row">
                      <img class="wh260 fit-cover brt10" :src="getImageUrl(item.image ? item.image : '')" alt="">
                    </div>
                    <div class="w260 pt10 pb12">
                      <div class="w-per100 row nowrap a-center o-h">
                        <span class="text-nowrap over-h ft24 lh36">{{ item.name }}</span>
                      </div>
                      <!-- 价格 -->
                      <div class="w-per100 mt16 lh24">
                        <span class="">
                          <span class="ft18 c-E02A22 font-Bold">￥</span>
                          <span class="ft28 c-E02A22 font-Bold">{{Math.floor(item.price)}}</span>
                          <span class="ft20 c-E02A22 font-Bold">{{String(item.price).includes('.')?'.':''}}</span>
                          <span class="ft20 c-E02A22 font-Bold">{{String(item.price).includes('.')?String(item.price).slice(String(item.price).indexOf('.')+1):''}}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ft18 row flex-center pointer pageBtn c-w absolute top-per50 trY-per50 left0 zIndex1" :class="showPage2==1?'bg-DCDCDC':'bg-00903B'" @click="change2(-1)">
                  {{'<'}}
                </div>
                <div class="ft18 row flex-center pointer pageBtn ml20 c-w absolute top-per50 trY-per50 right0 zIndex1" :class="showPage2==showLastPage2?'bg-DCDCDC':'bg-00903B'" @click="change2(1)">
                  {{'>'}}
                </div>
              </div>
              <div class="py30 c-9 ft16" v-else>
                {{$t('暂无数据')}}
              </div>
            </div>
          </div>

          <!-- 今日热销 -->
          <div class="w-per100 bg-w mt15 br10 hotBox">
            <div class="w-per100 py20 row j-sb a-center bdb-F2F2F2">
              <div class="row a-center">
                <div class="ml20 ft24 font-Bold">
                  {{$t('今日热销')}}
                </div>
              </div>
              <div class="c-9 ft16 pr40 pointer" @click="toSearch({id:0})">
                {{$t('查看更多')}}
              </div>
            </div>

            <div class="w-per100 px30">
              <div class="w-per100 relative minh300" v-if="showList3.length>0">
                <div class="w-per100 row nowrap">
                  <div class="w-per15_33 mt24 pointer" v-for="(item,index) in showList3" :key="index" @click="toDetail(item)">
                    <div class="wh200 brt10 row">
                      <img class="wh200 fit-cover brt10" :src="getImageUrl(item.image ? item.image : '')" alt="">
                    </div>
                    <div class="w200 pt10 pb12">
                      <div class="w-per100 row nowrap a-center o-h">
                        <span class="text-nowrap over-h ft20 lh36">{{ item.name }}</span>
                      </div>
                      <!-- 价格 -->
                      <div class="w-per100 mt16 lh24">
                        <span class="">
                          <span class="ft18 c-E02A22 font-Bold">￥</span>
                          <span class="ft28 c-E02A22 font-Bold">{{Math.floor(item.price)}}</span>
                          <span class="ft20 c-E02A22 font-Bold">{{String(item.price).includes('.')?'.':''}}</span>
                          <span class="ft20 c-E02A22 font-Bold">{{String(item.price).includes('.')?String(item.price).slice(String(item.price).indexOf('.')+1):''}}</span>
                        </span>
                        <span class="mt8 ft16 c-9">
                          &nbsp;{{locale=='en' ? (item.total_volume>=1000 ? `${$t('已抢')}${(item.total_volume/1000).toFixed(1)}${$t('万')}${$t('件')}` : `${$t('已抢')}${item.total_volume}${$t('件')}`) : ( item.total_volume>=10000 ? `${$t('已抢')}${(item.total_volume/10000).toFixed(1)}${$t('万')}${$t('件')}` : `${$t('已抢')}${item.total_volume}${$t('件')}` )}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ft18 row flex-center pointer pageBtn c-w absolute top-per50 trY-per50 left0 zIndex1" :class="showPage3==1?'bg-DCDCDC':'bg-00903B'" @click="change3(-1)">
                  {{'<'}}
                </div>
                <div class="ft18 row flex-center pointer pageBtn ml20 c-w absolute top-per50 trY-per50 right0 zIndex1" :class="showPage3==showLastPage3?'bg-DCDCDC':'bg-00903B'" @click="change3(1)">
                  {{'>'}}
                </div>
              </div>
              <div class="py30 c-9 ft16" v-else>
                {{$t('暂无数据')}}
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

    <MyFooter />
  </div>
  
</template>

<script>
import { mapGetters } from 'vuex';
import { pageMetaInfo } from "@/utils/seo";
import { goodsCategory, getShopBanner, getGoods, adBanner } from "@/api/app";
import goodsNameTag from "@/components/goods/goodsNameTag.vue";
import goodsTag from "@/components/goods/goodsTag.vue";
export default {
  metaInfo() {
    return pageMetaInfo(this, '商城首页', { pageKey: 'Mall' });
  },
  components:{
    goodsNameTag,
    goodsTag
  },
  data() {
    return {
      current:8,
      
      categoryList:[],
      banners:[],
      tagList:[],//百亿补贴
      sellList:[],//佰信畅销
      shareImg:{},//分享赚钱图片
			smallList:[],//小商品
			imgList:[],//图片广告
      category_one:0,//一级分类id
      category_two:0,//二级分类id
      sales_volume:false,//销量
      price_type:false,//价格
      desc_type:'total_volume desc',
      dataList:[],//今日推荐
      page:1,
      last_page:0,
      per_page:10,
      showList2:[],//猜你喜欢
      showPage2:1,
      showLastPage2:0,
      showList3:[],//今日热销
      showPage3:1,
      showLastPage3:0,
      locale:window.localStorage.getItem('language'),
    }
  },
  computed: {
    ...mapGetters({
      PageTitle:'computedSeo1',
      PagekeyWords:'computedSeo2',
      PageDescription:'computedSeo3',
      token:'computedToken',
      userInfo:'computedUserInfo',
    })
  },
  mounted() {
    // console.log('locale',this.locale);
    this.getAd();
    this._goodsCategory();
    this._getShopBanner();
    this.getGoodsTags();
    this.getGoodsSell();
    this.getRecGoodsList();
    this.getGoodsList();
    this.getGoodsLike();
    this.getGoodsHot();
  },
  methods: {
    // 今日热销
    change3(i){
      if(i==1){
        if(this.showPage3 == this.showLastPage3) return;
        this.showPage3++;
      }else{
        if(this.showPage3 == 1) return;
        this.showPage3--;
      }
      this.getGoodsHot();
    },
    // 猜你喜欢
    change2(i){
      if(i==1){
        if(this.showPage2 == this.showLastPage2) return;
        this.showPage2++;
      }else{
        if(this.showPage2 == 1) return;
        this.showPage2--;
      }
      this.getGoodsLike();
    },
    // 排序-价格
    changePrice(){
      this.price_type = !this.price_type;
      this.sales_volume = false;
      this.desc_type = this.price_type?'price desc':'price';
      this.page = 1;
      this.getGoodsList();
    },
    // 排序-销量
    changeSales(){
      this.sales_volume = !this.sales_volume;
      this.price_type = false;
      this.desc_type = this.sales_volume?'total_volume':'total_volume desc';
      this.page = 1;
      this.getGoodsList();
    },
    toCenter(){
      this.$router.push({
        path: "/Mine",
      })
    },
    // 去详情
    toDetail(item){
      this.$router.push({
        path:'/Goods',
        query:{
          id:item.id,
        }
      })
    },
    // 去搜索
    toSearch(item){
      this.$router.push({
        path:'/Search',
        query:{
          category_one:0,
          category_two:item.id,
        }
      })
    },
    // 跳转
    toPush(path){
      if(this.token){
        this.$router.push({
          path:path
        })
      }else{
        this.$message.error(this.$t('请登录'))
        setTimeout(()=>{
          this.toLogin();
        },1200);
      }
    },
    // 去登录
    toLogin(){
      this.$router.push({
        path:'/Login'
      })
    },
    // banner跳转
    toPath(item) {
      console.log('b',item);
      let u = item.url;
      let str = u.slice(u.indexOf('?')+1);
      let a = str.split('&');
      if(u.includes('/pages/index/index')){
        let p = {
          category_one:a[0]?a[0].slice(a[0].indexOf('=') + 1):0,
          category_two:a[1]?a[1].slice(a[1].indexOf('=') + 1):0,
        }
        let category_one = p.category_one?Number(p.category_one):0;
				let category_two = p.category_two?Number(p.category_two):0;
        this.$router.push({
          path:'/Search',
          query:{
            category_one:category_one,
            category_two:category_two,
          }
        })
      }else if(u.includes('/pagesIndex/goodsDetail/goodsDetail')){
        let id = a[0]?a[0].slice(a[0].indexOf('=') + 1):0;
        this.$router.push({
          path: "/Goods",
          query:{
            id:id,
          }
        })
      }else if(u.includes('/pagesMy/distributionShare/distributionShare')){
        let id = a[0]?a[0].slice(a[0].indexOf('=') + 1):0;
        this.$router.push({
          path: "/Share",
        })
      }else{
        if(u){
          window.location.href = item.url;
        }
      }
    },
    // 今日热销
    async getGoodsHot(){
      let params = {
        keywords:'',
        category_id1:0,
        category_id:0,
        is_rec:0,
        order:'total_volume desc',
        page:this.showPage3,
        per_page:7,
      }
      let {data} = await getGoods(params);
      if(data.code == 1){
        this.showLastPage3 = data.data.last_page;
        this.showList3 = data.data.data;
      }else{
        this.$message.error(data.msg);
      }
    },
    // 猜你喜欢
    async getGoodsLike(){
      let params = {
        keywords:'',
        category_id1:0,
        category_id:0,
        is_rec:0,
        order:'price',
        page:this.showPage2,
        per_page:5,
      }
      let {data} = await getGoods(params);
      if(data.code == 1){
        this.showLastPage2 = data.data.last_page;
        this.showList2 = data.data.data;
      }else{
        this.$message.error(data.msg);
      }
    },
    // 商品列表
    async getGoodsList(){
      let params = {
        keywords:'',
        category_id1:0,
        category_id:0,
        is_rec:0,
        order:this.desc_type,
        page:this.page,
        per_page:10,
      }
      let {data} = await getGoods(params);
      if(data.code == 1){
        this.last_page = data.data.last_page;
        if(this.page === 1){
          this.dataList = data.data.data;
        }else{
          let temp = this.dataList;
          let temp1 = data.data.data;
          if (temp1.length > 0) {
            temp.push(...temp1);
            this.dataList = temp;
          }
        }
      }else{
        this.$message.error(data.msg);
      }
    },
    // 畅销
    async getGoodsSell(){
      let params = {
        keywords:'',
        category_id1:0,
        category_id:0,
        is_rec:0,
        order:'total_volume desc',
        page:1,
        per_page:2,
      }
      let {data} = await getGoods(params);
      if(data.code == 1){
        this.sellList = data.data.data;
      }else{
        this.$message.error(data.msg);
      }
    },
    // 百亿补贴
    async getGoodsTags(){
      let params = {
        keywords:'',
        category_id1:0,
        category_id:0,
        is_rec:0,
        order:'price desc',
        page:1,
        per_page:3,
      }
      let {data} = await getGoods(params);
      if(data.code == 1){
        this.tagList = data.data.data;
      }else{
        this.$message.error(data.msg);
      }
    },
    // 分享赚钱后面小商品
    async getRecGoodsList(){
      let params = {
        keywords:'',
        category_id1:0,
        category_id:0,
        is_rec:1,
        order:'price',
        page:1,
        per_page:20,
      }
      let {data} = await getGoods(params);
      if(data.code == 1){
        this.smallList = data.data.data;
      }else{
        this.$message.error(data.msg);
      }
    },
    // 广告位
    async getAd(){
      let {data} = await adBanner();
      if(data.code == 1){
        let list = data.data;
        if(list.length>0){
          this.shareImg = list[0];
          this.imgList = list.length>1?list.slice(1):[];
        }
      }else{
        this.$message.error(data.msg);
      }
    },
    // 轮播图
    async _getShopBanner(){
      let {data} = await getShopBanner();
      if(data.code == 1){
        this.banners = data.data.list;
        // this.shareImg = data.data.position1;
				// this.imgList = [data.data.position2,data.data.position3,data.data.position4];
      }else{
        this.$message.error(data.msg);
      }
    },
    // 二级分类
    async _goodsCategory(){
      let {data} = await goodsCategory();
      if(data.code == 1){
        this.categoryList = data.data;
      }else{
        this.$message.error(data.msg);
      }
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-carousel__indicators{
  padding: 0;
  .el-carousel__indicator--horizontal{
    padding: 14px;
  }
  .el-carousel__button{
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #ffffff;
    opacity: 0.3;
  }
}
::v-deep .is-active{
  .el-carousel__button{
    background: #ffffff;
    opacity: 1;
  }
}
.butie{
  width: 3.1771vw;
  height: 0.8854vw;
}
.pageBtn{
  width: 1.7708vw;
  height: 2.8125vw;
}
@media screen and (min-width: 750px) and (max-width: 1250px){
::v-deep .el-carousel__indicators{
  .el-carousel__indicator--horizontal{
    padding: 8px;
  }
}
.h300{height: 20.3125vw;}
::v-deep .el-carousel__container{
  height: 20.3125vw !important;
  .h300{height: 20.3125vw;}
}
.butie{
  width: 6.3542vw;
  height: 1.7708vw;
}
.h40{
  height: 3.125vw;
}
.tuijian{
  .wh280{
    width: 17.5vw;
    height: 17.5vw;
  }
  .w280{width: 17.5vw;}
}
.w150{width: 9.375vw;}
.h190{height: 11.875vw;}
.likeBox{
  .wh260{
    width: 16.25vw;
    height: 16.25vw;
  }
  .w260{width: 16.25vw;}
}
.pageBtn{
  width: 2.125vw;
  height: 3.375vw;
}
.hotBox{
  .wh200{
    width: 12.5vw;
    height: 12.5vw;
  }
  .w200{width: 12.5vw;}
}
}
@media screen and (max-width: 750px){
::v-deep .el-carousel__indicators{
  padding: 0;
  .el-carousel__indicator--horizontal{
    padding: 4px;
  }
  .el-carousel__button{
    width: 8px;
    height: 8px;
  }
}
.h300{height: 23.4375vw;}
::v-deep .el-carousel__container{
  height: 23.4375vw !important;
  .h300{height: 23.4375vw;}
}
.butie{
  width: 6.3542vw;
  height: 1.7708vw;
}
.h40{
  height: 4.1667vw;
}
.tuijian{
  .wh280{
    width: 17.5vw;
    height: 17.5vw;
  }
  .w280{width: 17.5vw;}
  .mt8 {margin-top: 2.0833vw;}
}
.w150{width: 12.5vw;}
.h190{height: 15.8333vw;}
.w110{width: 9.1667vw;}
.wh110{
  width: 9.1667vw;
  height: 9.1667vw;
}
.likeBox{
  .wh260{
    width: 17.6042vw;
    height: 17.6042vw;
  }
  .w260{width: 17.6042vw;}
}
.pageBtn{
  width: 2.65625vw;
  height: 4.21875vw;
}
.hotBox{
  .wh200{
    width: 12.5vw;
    height: 12.5vw;
  }
  .w200{width: 12.5vw;}
}
}
</style>